import { Pipe, PipeTransform } from '@angular/core';
import { fromUnixTime } from 'date-fns';

@Pipe({
    name: 'unixToDate',
    pure: true,
    standalone: false
})
export class UnixToDatePipe implements PipeTransform {
  transform(value: any, ...args: any[]) {
    return fromUnixTime(value);
  }
}
